import React from 'react'
export function formatPhone(digits) {
  if (digits.length === 10 || digits.length === 11 && digits[0] === "1") {
    digits = digits.replace(/^1/, "")
    return "(" + digits.slice(0, 3) + ") " + digits.slice(3, 6) + "-" + digits.slice(6)
  } else {
    return digits
  }
}

export const errorClasses = (matchErrors) => (...errorTypes)  => {
  const hasAny = !!errorTypes.find(x => matchErrors.indexOf(x) > -1);
  if (hasAny) {
    return "text-danger"
  } else {
    return ""
  }
}


export function locationToListingSummary(location) {
  return {
    businessName: location.businessName,
    street: location.businessAddress.street,
    suite: location.businessAddress.suite,
    city: location.businessAddress.city,
    state: location.businessAddress.state,
    postalCode: location.businessAddress.postalCode,
    phoneNumber: location.phoneNumber,
    website: location.website[0],
  }
}


export function MaybeLink({children, href, ...props}) {
  return href ? <a href={href} target="_blank" {...props}>{children}</a> : <span {...props}>{children}</span>
}
